import GamesListModel from "./GamesListModel";

export default class GameByIdModel extends GamesListModel {
  public adContent: string = null;
}
